export default __webpack_public_path__ + "static/media/1.7d66c0f9.png";